var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.555814 14.51H15.1033C15.2338 14.51 15.3599 14.4643 15.4599 14.3811C15.5997 14.2641 18.787 11.5222 18.9814 5.60333H3.35762C3.16401 10.976 0.228606 13.5014 0.1981 13.5266C0.0192622 13.6777 -0.0465357 13.9245 0.033921 14.1441C0.113821 14.3632 0.322051 14.51 0.555814 14.51Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4433 2.26332H15.66V1.70666C15.66 1.39493 15.415 1.14999 15.1033 1.14999C14.7916 1.14999 14.5466 1.39493 14.5466 1.70666V2.26332H11.7262V1.70666C11.7262 1.39493 11.4813 1.14999 11.1695 1.14999C10.8578 1.14999 10.6129 1.39493 10.6129 1.70666V2.26332H7.82955V1.70666C7.82955 1.39493 7.58461 1.14999 7.27288 1.14999C6.96115 1.14999 6.71621 1.39493 6.71621 1.70666V2.26332H3.93289C3.62115 2.26332 3.37622 2.50826 3.37622 2.81999V4.48999H19V2.81999C19 2.50826 18.755 2.26332 18.4433 2.26332Z",
    fill: "#111F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1748 15.2346C15.8725 15.4863 15.4931 15.6233 15.1033 15.6233H3.37625V17.2933C3.37625 17.601 3.62523 17.85 3.93292 17.85H18.4433C18.751 17.85 19 17.601 19 17.2933V11.0533C17.9267 13.6863 16.4291 15.0218 16.1748 15.2346Z",
    fill: "#111F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/dateIcon.ad81a3de059246bf15a65ae2fe40d479.svg";
export { ForwardRef as ReactComponent };